import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

import { CardAutocomplete } from 'components/Form';
import { IconWrapper } from 'components/Icon';
import { searchCompanyUsers } from 'features/companies/api/getCompanyUsers';

const UserItem = ({ full_name, ...rest }) => (
  <Stack gap={1} alignItems={'flex-start !important'} {...rest}>
    <Typography variant="body1" fontWeight="bold">
      {full_name}
    </Typography>
  </Stack>
);

export const AssignedUserFilter = ({ companyID, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(null);

  const handleOpen = () => {
    setDraft(value);
    setOpen(true);
  };

  const handleChange = (newValue) => {
    setDraft(newValue ? { user_id: newValue.user_id, full_name: newValue.full_name } : null);
  };

  const handleClear = () => {
    onChange(null);
    setOpen(false);
  };

  const handleConfirm = () => {
    onChange(draft);
    setOpen(false);
  };

  return (
    <Box flexShrink={0}>
      <Button
        variant="outlined"
        onClick={handleOpen}
        sx={{
          backgroundColor: "background.paper",
          borderRadius: 1,
          fontWeight: 400,
          lineHeight: "24px",
          fontFeatureSettings: '"liga" off, "cling" off',
          color: 'text.primary',
          borderColor: 'divider',
          whiteSpace: 'nowrap',
        }}
        endIcon={
          <IconWrapper
            icon="chevronDown"
            sx={{
                height: 14,
                width: 14,
                svg: {
                    stroke: "#000",
                    strokeWidth:1,
                    height: 14,
                    width: 14,
                    mt: -1.25,
                },
                ml: 1,
            }}
            height={14}
          />
        }
      >
        Assigned to {value?.full_name && `(${value.full_name})`}
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Assigned to</DialogTitle>
        <DialogContent>
          <CardAutocomplete
            name="assignedUserFilter"
            label="Select User"
            queryFunction={(search) => searchCompanyUsers(companyID, search)}
            optionLabelName="full_name"
            ItemCard={UserItem}
            onChange={handleChange}
            value={draft ? { ...draft, label: draft.full_name } : null}
            skipCreatingShadow={true}
            fetchOnOpen={true}
            fullWidth
            changeSelectedValueOnChange={true}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClear}>Clear</Button>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleConfirm} variant="contained">Confirm</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
